// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3OTJX","container":"styles_container__2lJp7","title":"styles_title__Z5hiI","wrapper":"styles_wrapper__2Rzr0","answer":"styles_answer__2I5Sv"};